import { UserType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IUserMicrosoftAccount, UserMicrosoftAccount } from "ui/Scripts/source/models/user/userMicrosoftAccount";

export interface IUserProfileEditItem {
    code: string;
    firstName: string;
    lastName: string;
    email: string;
    emailNotificationType: number;
    pushNotificationType: number;
    instantMessageUserInvitationAcceptType: number;
    picture: string;
    loginCompanyCode: string;
    userType: UserType;
    qrCodeId: string;
    rowId: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    microsoftAccount: IUserMicrosoftAccount;
}

export class UserProfileEditItem implements IUserProfileEditItem {
    code: string;
    firstName: string;
    lastName: string;
    email: string;
    emailNotificationType: number;
    pushNotificationType: number;
    instantMessageUserInvitationAcceptType: number;
    picture: string;
    loginCompanyCode: string;
    userType: UserType;
    qrCodeId: string;
    rowId: string;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    microsoftAccount: UserMicrosoftAccount;

    constructor();
    constructor(obj: IUserProfileEditItem);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.email = obj && obj.email || "";
        this.emailNotificationType = obj && obj.emailNotificationType || 0;
        this.pushNotificationType = obj && obj.pushNotificationType || 0;
        this.instantMessageUserInvitationAcceptType = obj && obj.instantMessageUserInvitationAcceptType || 0;
        this.picture = obj && obj.picture || "";
        this.loginCompanyCode = obj && obj.loginCompanyCode || "";
        this.userType = obj && obj.userType || UserType.Normal;
        this.qrCodeId = obj && obj.qrCodeId || "";
        this.rowId = obj && obj.rowId || "";
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.microsoftAccount = obj && obj.microsoftAccount
            ? new UserMicrosoftAccount(obj.microsoftAccount)
            : null;
    }
}